import React, { useState, useContext } from 'react'
import CircleProgress from '../../components/CircleProgress/CircleProgress';
import SySbackground from '../../components/SySbackground/SySbackground';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { VisibilityIcon, VisibilityOffIcon, KeyIcon, AccountCircleIcon } from '../../assets/icons/icons';
import SysCubeLogo from '../../assets/svgs/systrategy_cube_logo.svg';
import sysLogo from '../../assets/svgs/systrategy_logo.svg';
import './ForgotPassword.css';
import { AuthContext } from '../../contexts/authContext';
import { testEmail, testPasswordValidator, inputOnlyNumbers } from '../../utils/CommonUtilities';
import IGPLogoWhite from '../../assets/svgs/IGPDecauxWhite.svg';
import useNotification from '../../hooks/useNotification';

import { InputLabel } from '@mui/material';

function ForgotPassword() {

    const navigate = useNavigate();
    const { notificationSuccess, notificationError, notificationInfo } = useNotification();
    const auth = useContext(AuthContext);
    const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [codeSent, setCodeSent] = useState(false);

    const requestCode = async() => {
        try{
            await auth.sendCode(email);

            notificationInfo("È stata inviata una mail contenente il codice.");
            setCodeSent(true);
        }catch(e){
            notificationError('Email non esistente');
        }
    }

    const forgotPassword = async() => {
        try{
            await auth.forgotPassword(email, code, newPassword);
            notificationSuccess("Procedura completata.");
            navigate('/signin');
        }catch(e){
            notificationError('Codice non valido o Password non conforme');
        }
    }

    return (
        <div className='forgotPassword'>
            {forgotPasswordLoading && (<CircleProgress isDialog={true}/>)}
            <div id="forgotPassword-form" className="forgotPassword-container">
                <div className="app-login-header">
                    <a href="https://www.igpdecaux.it/it" target="_blank" rel="noreferrer">
                        <img
                            src         ={IGPLogoWhite}
                            alt         ="IGPDecaux"
                            draggable   ="false"
                            className   ="igp-logo"
                        />
                    </a>
                </div>
                <div className="user-psw-container">
                    {!codeSent&&(<>
                        
                        <FormControl className="forgotPassword-credentials-wrapper top">
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <OutlinedInput
                                name            ="email"
                                id='email'
                                label="Email"
                                value           ={ email }
                                placeholder     ="Email"
                                spellCheck      ={ false }
                                onChange        ={ e => { setEmail(e.target.value); } }
                            />
                        </FormControl>
                        
                        <div className="button-wrapper">
                            <Button
                                variant     = "outlined"
                                type='submit'
                                className   ={ "text-uppercase forgotPassword-btn" }
                                onClick={requestCode}
                                disabled={!testEmail(email)}
                            >Richiedi</Button>
                            <div
                                className   ={ "text-uppercase forgot-password-label" }
                                onClick     ={ ()=>navigate('/signin') }
                            >Login</div>
                        </div>
                    </>)}

                    {codeSent&&(<>
                        <FormControl className="forgotPassword-credentials-wrapper">
                        <InputLabel htmlFor="code">Codice</InputLabel>
                            <OutlinedInput
                                name            ="code"
                                id              ="code"
                                label="Codice"
                                placeholder     ="Codice"
                                type            ='text'
                                value           ={ code }
                                onChange        ={ e => { setCode(e.target.value); } }
                            />
                        </FormControl>
                        <FormControl className="forgotPassword-credentials-wrapper">
                        <InputLabel htmlFor="new-password">Nuova Password</InputLabel>
                            <OutlinedInput
                                name            ="new-password"
                                id              ="new-password"
                                label="Nuova Password"
                                placeholder     ="Nuova Password"
                                type            ={ showNewPassword ? 'text' : 'password' }
                                value           ={ newPassword }
                                onChange        ={ e => { setNewPassword(e.target.value); } }
                                spellCheck      ={ false }
                                error={!testPasswordValidator(newPassword)}
                                endAdornment    ={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label ="toggle password visibility"
                                            onClick    ={ () => { setShowNewPassword(!showNewPassword); } }
                                        >
                                            { showNewPassword ? <VisibilityIcon/> : <VisibilityOffIcon/> }
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <FormControl className="forgotPassword-credentials-wrapper">
                        <InputLabel htmlFor="confirm-password">Conferma Password</InputLabel>
                            <OutlinedInput
                                name            ="confirm-password"
                                id              ="confirm-password"
                                label="Conferma Password"
                                placeholder     ="Conferma Password"
                                type            ={ showConfirmPassword ? 'text' : 'password' }
                                value           ={ confirmPassword }
                                onChange        ={ e => { setConfirmPassword(e.target.value); } }
                                spellCheck      ={ false }
                                error={newPassword !== confirmPassword}
                                endAdornment    ={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label ="toggle password visibility"
                                            onClick    ={ e => { setShowConfirmPassword(!showConfirmPassword); } }
                                        >
                                            { showConfirmPassword ? <VisibilityIcon/> : <VisibilityOffIcon/> }
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <div className='password-info'>
                            <span className={newPassword.length>=14 ? 'green-txt' : 'red-txt'}>Minimo 14 caratteri e deve contenere almeno: </span>
                            <div className='password-info-group'>
                                <span className={/[a-z]/.test(newPassword) ? 'green-txt' : 'red-txt'}>1 Carattere maiuscolo</span>
                                <span className={/[A-Z]/.test(newPassword) ? 'green-txt' : 'red-txt'}>1 Carattere minuscolo</span>
                                <span className={/\d/.test(newPassword) ? 'green-txt' : 'red-txt'}>1 Numero</span>
                                <span className={/[\^$*.[\]{}()?"!@#%&\/,><\\':;|_~`=+-]/.test(newPassword) ? 'green-txt' : 'red-txt'}>1 Carattere speciale</span>
                            </div>
                        </div>
                        <div className="button-wrapper">
                            <Button
                                variant     = "outlined"
                                type='button'
                                className   ={ "text-uppercase forgotPassword-btn" }
                                onClick={forgotPassword}
                                disabled={code==='' || (newPassword !== confirmPassword) || newPassword === '' || confirmPassword==='' || !testPasswordValidator(newPassword) || !testPasswordValidator(confirmPassword)}
                            >Conferma</Button>
                            <div className='forgot-extra-btns'>
                                <div
                                    className   ={ "text-uppercase forgot-password-label" }
                                    onClick     ={ ()=>{setEmail('');setCodeSent(false)} }
                                >
                                    Rinvia Codice
                                </div>
                                <div
                                    className   ={ "text-uppercase forgot-password-label" }
                                    onClick     ={ ()=>navigate('/signin') }
                                >Login</div>
                            </div>
                        </div>
                    </>)}
                </div>
                <div className="footer-info top-bottom-section"></div>
            </div>
        </div>
    )
}

export default ForgotPassword